import useLangText from '@shared/hooks/useLangText';
import {
    ProcessFieldBase,
    type ProcessFieldFloat as ProcessFieldFloatType,
} from '@shared/types/process';

import {
    maskitoNumberOptionsGenerator,
    MaskitoNumberParams,
} from '@maskito/kit';
import { ShadcnForm } from '@shadcn-features/core';
import { ShadcnFormInputNumberProps } from '@shadcn-features/core/ShadcnForm/fields/ShadcnFormInputNumber';
import { ShadcnFormRule } from '@shadcn-features/core/ShadcnForm/types';

interface Props extends ShadcnFormInputNumberProps<
    typeof ShadcnForm.InputNumber
> {
    field: ProcessFieldBase & ProcessFieldFloatType;
}

export function ProcessFieldFloatField({ field, fieldProps, ...props }: Props) {
    const getLangText = useLangText();

    const maskitoNumberParams: MaskitoNumberParams = {
        decimalSeparator: field.options.decimalSeparator ?? '.',
        thousandSeparator: field.options.thousandSeparator ?? ' ',
        maximumFractionDigits: field.options.maxFractionDigits ?? 0,
        minimumFractionDigits: field.options.minFractionDigits ?? 0,
        max: field.options.maxValue ?? undefined,
        min: field.options.minValue ?? undefined,
    };
    const params = maskitoNumberOptionsGenerator(maskitoNumberParams);

    return (
        <ShadcnForm.InputNumber
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            rules={props.rules as ShadcnFormRule<unknown>[]}
            {...props}
            maskito={params}
            maskitoNumberParams={maskitoNumberParams}
            tooltip={getLangText(field?.tooltip ?? '')}
            type='text'
            fieldProps={{
                ...fieldProps,
                stringMode: true,
            }}
        />
    );
}
